export const INCREMENT = "INCREMENT";
export const DECREMENT = "DECREMENT";

export const ADD_REVIEW = "ADD_REVIEW";

export const FETCH_RESTAURANTS = "FETCH_RESTAURANTS";

export const FETCH_PRODUCTS = "FETCH_PRODUCTS";

export const FETCH_REVIEWS = "FETCH_REVIEWS";

export const FETCH_USERS = "FETCH_USERS";

export const START = "_START";
export const SUCCESS = "_SUCCESS";
export const ERROR = "_ERROR";
